// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rO-z","hovered":"sO-z","hoverImage":"tO-z","mainImage":"uO-z","imageNoBackground":"vO-z","fullSizeImage":"wO-z"};